import styled from 'styled-components'
import Pill from 'src/comps/Atom/Pill'
import { updatedMedia } from 'client/styles'

export const PaxesSelectorInput = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 4px;

  & > div {
    padding-inline-start: 20px;
  }
`

export const PillFullMode = styled(Pill)`
  border: 2px solid transparent;
  justify-content: flex-start;
  height: 48px;

  &:hover {
    background: var(--color--neutral--300);
    border: 2px solid var(--color--neutral--100);
  }

  ${updatedMedia.desktop} {
    justify-content: center;
  }
`
